import Network from 'lib/api/network';

export default {
  namespaced: true,

  state() {
    return {
      program: {},
    };
  },

  mutations: {
    updateProgramKey(state, { key, value }) {
      state.program[key] = value;
    },

    addNewChannel(state, channelName) {
      if (!state.program.channels) state.program.channels = [];
      state.program.channels.push({ name: `#${channelName}`, id: channelName });
    },
  },

  actions: {
    activateProgram({ state, commit, dispatch }, { tags }) {
      commit('update', { key: 'formSubmitted', value: true }, { root: true });
      return new Promise(() => {
        Network.post(
          '/shoutouts/activate',
          {},
          {
            success: ({ toast }) => {
              window.donut.track('Shoutouts Launch - Activated (FE)');
              commit('updateProgramKey', { key: 'state', value: 'active' });
              dispatch('setSuccessToast', toast, { root: true });
              commit('startConfetti', null, { root: true });
              commit('updateModal', {
                visible: true,
                subcomponent: 'shoutouts-programs-modals-launch-announcement',
                size: 'xl',
                data: { tags },
              }, { root: true });
            },
            error: () => {
              dispatch('setErrorToast', 'There was an error with launch.', { root: true });
            },
            complete: () => {
              commit('update', { key: 'formSubmitted', value: false }, { root: true });
            },
          },
        );
      });
    },

    announceProgram({ commit, dispatch }, { channels, text }) {
      commit('update', { key: 'formSubmitted', value: true }, { root: true });
      return new Promise(() => {
        Network.post(
          '/shoutouts/announce',
          { announce: { channels, text } },
          {
            success: () => {
              dispatch('setSuccessToast', 'Announcement sent successfully!', { root: true });
              commit('closeModal', null, { root: true });
            },
            error: () => {
              dispatch('setErrorToast', 'There was an error sending the announcement.', { root: true });
            },
            complete: () => {
              commit('update', { key: 'formSubmitted', value: false }, { root: true });
            },
          },
        );
      });
    },

    updateProgram({ commit, dispatch }, { params, successToast, errorToast }) {
      return new Promise((resolve) => {
        Network.put('/shoutouts/settings', { shoutouts_program: params }, {
          success: (updatedProgram) => {
            Object.keys(params).forEach((key) => {
              commit('updateProgramKey', { key, value: updatedProgram[key] });
            });
            dispatch('setSuccessToast', successToast, { root: true });
          },
          error: () => { dispatch('setErrorToast', errorToast, { root: true }); },
          complete: () => { resolve(); },
        });
      });
    },

    updateReactionsEnabled({ dispatch }, { val }) {
      // This is just a wrapper for updateProgram, but it requires some finessing since its passed wholesale into the toggle component
      const verb = val ? 'enable' : 'disable';
      return dispatch('updateProgram', { params: { reactions_enabled: val }, successToast: `Successfully ${verb}d reactions!`, errorToast: `Failed to ${verb} reactions.` });
    },

    updateRestrictToNotificationChannels({ dispatch }, { val }) {
      const successToast = val
        ? 'Shoutouts are now limited to your selected channels.'
        : 'Shoutouts can now be given in any channel Donut is in.';
      return dispatch('updateProgram', { params: { restrict_to_notification_channels: val }, successToast, errorToast: 'Failed to update channel restriction.' });
    },
  },
};
